import React from 'react'
import './portfoli.css'
import Img1 from '../../items/Ecom.PNG'
import Img2 from '../../items/invoice.PNG'
import Img3 from '../../items/greenscale.PNG'
import Img4 from '../../items/quiz.PNG'
import Img5 from '../../items/netflix.PNG'

const data = [
  {
    id: 1,
    image: Img1,
    title: 'Ecommerce Website',
    github: 'https://github.com/Kshitij77/ecom-Website',
    view: 'https://kshitij-ecomm.000webhostapp.com/index.php',
  },
  {
    id: 2,
    image: Img2,
    title: 'Ai Enabled Invoice Management Application',
    github: 'https://github.com/Kshitij77/AI-Enabled-Invoice-Management-Application',
  },
  {
    id: 3,
    image: Img5,
    title: 'Netflix Movies Trailer(FrontEnd)',
    github: 'https://github.com/Kshitij77/TrailersApp',
    view: 'https://netflix-trailersapp.herokuapp.com/'
  },
  {
    id: 4,
    image: Img4,
    title: 'Online Quiz Website',
    github: 'https://github.com/Kshitij77/Online-Quiz-Website',
    view: 'https://quizzzzlet.000webhostapp.com/index.php'
  },
  {
    id: 5,
    image: Img3,
    title: 'Image Filters and Steganography',
    github: 'https://github.com/Kshitij77/ImageFilters-and-Steganography',
  }
]

const Portfoli = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Works</h5>
      <h2>Projects</h2>
      <div className='container portfolio__container'>
        {
          data.map(({id, image, title, github, view}) =>{
            return(
              <article key={id} className='portfolio__item'>
                <div className='portfolio__item-image'>
                  <img src={image} alt={title} />
                </div>
                <h3>{title}</h3>
                <div className='portfolio__item__btn'>
                  <a href={github} target="_blank" className='btn'>Github</a>
                  <a href={view} target="_blank" className='btn'>View</a>
                </div>
              </article>
            )
          })
        }
      </div>
    </section>
  )
}

export default Portfoli